// src/pages/Users/Techniques/components/EmptyState.jsx
import React from "react";

export default function EmptyState() {
  return (
    <div className="text-center py-16">
      <div className="mx-auto w-16 h-16 rounded-full bg-slate-100 dark:bg-slate-800 mb-4" />
      <h4 className="text-lg font-semibold mb-1">Aucune technique trouvée</h4>
      <p className="text-slate-600 dark:text-slate-300">
        Essaie d’assouplir tes filtres ou de modifier la recherche.
      </p>
    </div>
  );
}
